import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { ThemeProvider } from "@mui/material";
import { THEME } from "./utils/themeMui";
import { ChakraProvider } from "@chakra-ui/react";
const App = React.lazy(() => import("./App"));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Suspense
    fallback={
      <div className="min-w-[100vw] min-h-[100vh] bg-bg-home flex justify-center items-center text-3xl text-primary-color">
        <BeatLoader color="#F0932B" size={"32px"} />
      </div>
    }
  >
    <ThemeProvider theme={THEME}>
      <ChakraProvider>
        <BrowserRouter basename="/">
          <App />
        </BrowserRouter>
      </ChakraProvider>
    </ThemeProvider>
  </Suspense>
);
